import { calculateAge } from './calculateAge';

export function isPatientOlderThanEighteenOnDate(patientBirthDate: string | Date, referenceDate?: Date | string) {
    return isPatientOlderThanGivenAgeOnDate(patientBirthDate, 18, referenceDate);
}

function isPatientOlderThanGivenAgeOnDate(
    patientBirthDate: string | Date,
    referenceAge: number,
    referenceDate?: Date | string
) {
    const age = calculateAge(patientBirthDate, referenceDate);

    return age >= referenceAge;
}
